//import React from 'react';
import glamorous from 'glamorous';

export const Container = glamorous.div({
  maxWidth: '800px',
  margin: '0 auto'
});

export const TextCenter = glamorous.div({
  textAlign: 'center'
});

export const H3 = glamorous.h3({
  color: '#888',
  fontSize: '16px',
  margin: '0 0 10px',
  textTransform: 'uppercase',
  fontWeight: '400'
});

export const Section = glamorous.div({
  margin: '60px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '@media(min-width: 500px)': {
    flexDirection: 'row'
  },
  '> div': {
    padding: '5px 16px',
    fontWeight: 300,
    lineHeight: '1.4'
  },
  '& img': {
    height: '100px'
  }
});



// WEBPACK FOOTER //
// ./src/components/Layout.js